import { type Psychologist } from '@avanta/shared/types/psychologists';
import { cn } from '@avanta/shared/utils/cn';
import { useFormContext } from 'react-hook-form';
import { AnimatedContainer } from 'components/ui/AnimatedContainer';
import { CONTAINER_SM_MAX_WIDTH } from '../../../styles';
import { AppointmentsReservePayload, defaultValues, type StepProps } from '../../../types';
import { DesktopView, MobileView } from './components';

export const SearchPsychologistStep = ({ handleNext }: StepProps): React.ReactElement => {
  const { setValue, reset, getValues } = useFormContext();

  const handleOnClick = (psychologist: Psychologist): void => {
    setValue(AppointmentsReservePayload.psychologist, psychologist);
    handleNext?.();
  };

  const handleOnBack = (): void => {
    reset({
      ...defaultValues,
      [AppointmentsReservePayload.timezone]: getValues(AppointmentsReservePayload.timezone),
    });
  };

  return (
    <AnimatedContainer className={cn(CONTAINER_SM_MAX_WIDTH, 'flex flex-col h-full')}>
      <DesktopView handleOnClick={handleOnClick} handleOnBack={handleOnBack} />
      <MobileView handleOnClick={handleOnClick} handleOnBack={handleOnBack} />
    </AnimatedContainer>
  );
};
